export const CLICK = {
  REGISTER_FROM_TEMPLATE: {
    CUSTOMIZE_TEMPLATE: {
      page: 'Template builder modal',
      target: 'Template builder modal after signing up using a template',
      label: 'Customize template',
    },
    START_INSPECTION: {
      page: 'Template builder modal',
      target: 'Template builder modal after signing up using a template',
      label: 'Start Inspection',
    },
  },
  REGISTER: {
    page: 'register',
    target: 'register-webapp',
    label: 'Registered',
  },
  UPGRADE_BUTTON: {
    page: '',
    target: '',
    label: 'Upgrade button',
  },
  STARTED_WATCHING_ONBOARD_VIDEO: {
    page: 'Empty dashboard',
    target: 'Onboard video',
    label: 'Started watching onboard video',
  },
  RESTRICT_AVAILABILITY: {
    page: 'Checklist builder',
    target: 'restrict-availability',
    label: 'Who should be entitled to fill the form',
  },
  ADD_REPORT_TEMPLATE: {
    page: 'Checklist builder',
    target: 'add-report-template',
    label: 'Add new report template',
  },
  SAVE_REPORT: {
    page: 'Checklist builder',
    target: 'save-report',
    label: 'Save report',
  },
  DISCARD_REPORT: {
    page: 'Checklist builder',
    target: 'discard-report',
    label: 'Discard report',
  },
  SET_CATEGORY: {
    page: 'Checklist builder',
    target: 'set-category-for-checklist',
    label: 'Set category',
  },
  SELECT_SUPERVISORS: {
    page: 'Checklist builder',
    target: 'select-supervisors',
    label: 'Select supervisors',
  },
  SELECT_ENTITY_ITEM: {
    page: 'Checklist builder',
    target: 'select-entity-item',
    label: 'Select entity item',
  },
  TO_BE_DONE_BY: {
    page: 'Checklist builder',
    target: 'to-be-done-by',
    label: 'Needs to be done by',
  },
  CHANGE_STAGE: {
    page: 'Checklist builder',
    target: 'change-stage',
  },
  SAVE_CHECKLIST: {
    page: 'Checklist builder',
    target: 'save-checklist',
  },
  ADD_LOGIC: {
    page: 'Checklist builder',
    target: 'add-logic',
  },
  ADD_LOGIC_QUESTION: {
    page: 'Checklist builder',
    target: 'logic-add-question',
  },
  ADD_LOGIC_SECTION: {
    page: 'Checklist builder',
    target: 'logic-add-section',
  },
  LOGIC_RAISE_ISSUE: {
    page: 'Checklist builder',
    target: 'logic-raise-issue',
  },
  LOGIC_RAISE_INSPECTION: {
    page: 'Checklist builder',
    target: 'logic-raise-inspection',
  },
  LOGIC_ADD_HIDE_FORM: {
    page: 'Checklist builder',
    target: 'logic-add-hide-form',
  },
  SET_ITEM_CATEGORY: {
    page: 'Checklist builder',
    target: 'set-category-for-item',
  },
  SET_ITEM_ENTITY_TYPE: {
    page: 'Checklist builder',
    target: 'set-entity-type-for-item',
  },
  SET_ITEM_ENTITY_FOLDER: {
    page: 'Checklist builder',
    target: 'set-entity-folder-for-item',
  },
  MULTIPLE_SELECTION_TOGGLE: {
    page: 'Checklist builder',
    label: 'Multiple selection',
    target: 'multiple-selection-toggle',
  },
  TEXT_COMMENT_TOGGLE: {
    page: 'Checklist builder',
    label: 'Text comment',
    target: 'text-comment-toggle',
  },
  PHOTO_COMMENT_TOGGLE: {
    page: 'Checklist builder',
    label: 'Photo comment',
    target: 'photo-comment-toggle',
  },
  REPORT_ISSUE_TOGGLE: {
    page: 'Checklist builder',
    label: 'Report issue',
    target: 'report-issue-toggle',
  },
  ALLOW_MULTIPLE_PHOTOS: {
    page: 'Checklist builder',
    label: 'Allow multiple photos',
    target: 'allow-multiple-photos-toggle',
  },
  ALLOW_DRAWING: {
    page: 'Checklist builder',
    label: 'Allow drawing',
    target: 'allow-drawing-toggle',
  },
  ALLOW_GALLERY_SELECTION: {
    page: 'Checklist builder',
    label: 'Allow gallery selection',
    target: 'allow-gallery-selection-toggle',
  },
  DATE_TOGGLE: {
    page: 'Checklist builder',
    label: 'Date toggle',
    target: 'date-toggle',
  },
  TIME_TOGGLE: {
    page: 'Checklist builder',
    label: 'Time toggle',
    target: 'time-toggle',
  },
  AUTOFILL_ENTITY_TOGGLE: {
    page: 'Checklist builder',
    label: 'Autofill entity toggle',
    target: 'autofill-entity-toggle',
  },
  ADD_IMAGE_TO_QUERY: {
    page: 'Checklist builder',
    label: 'Image to question',
    target: 'image-question',
  },
  ADD_FILE_TO_QUERY: {
    page: 'Checklist builder',
    label: 'File to question',
    target: 'file-question',
  },
  MORE_ICON_CLICK: {
    page: 'Checklist builder',
    target: 'more-icon-click',
  },
  DELETE_ITEM: {
    page: 'Checklist builder',
    target: 'delete-item',
  },
  CLONE_ITEM: {
    page: 'Checklist builder',
    target: 'clone-item',
  },
  TITLE_TOGGLE: {
    page: 'Checklist builder',
    label: 'Custom form title toggle',
    target: 'title-toggle',
  },
  INVOICE_DOWNLOAD: {
    page: 'Subscription overview',
    target: 'invoice-download',
    label: 'Download invoice',
  },
  CREATE_INSPECTION: {
    page: 'Templates index',
    target: 'inspection-create',
    label: 'Conduct inspection',
  },
  CREATE_TEMPLATE: {
    page: 'Templates index',
    target: 'create-template',
    label: 'Create template',
  },
  EDIT_TEMPLATE: {
    page: 'templates-index',
    target: 'edit-template',
    label: 'Edit form',
  },
  CLONE_TEMPLATE: {
    page: 'templates-index',
    target: 'clone-template',
    label: 'Clone template',
  },
  CHANGE_LOG_TEMPLATE: {
    page: 'templates-index',
    target: 'templates-model-change-log',
    label: 'View log history',
  },
  PREVIEW_TEMPLATE: {
    page: 'templates-index',
    target: 'template-previewed',
  },
  CREATE_TEMPLATE_FROM_SCRATCH: {
    page: 'Choose Template',
    target: 'create-template-from-scratch',
    label: 'Create template from scratch',
  },
  CREATE_READY_MADE_TEMPLATE: {
    page: 'Choose Template',
    target: 'create-ready-made-template',
    label: 'Create ready-made template',
  },
  CUSTOMIZE_READY_MADE_TEMPLATE: {
    page: 'Choose Template',
    target: 'customize-ready-made-template',
    label: 'Customize ready-made template',
  },
  CREATE_FILE_UPLOAD_TEMPLATE: {
    page: 'Upload template file',
    target: 'create-upload-file-template',
    label: 'Create upload file template',
  },
  CUSTOMIZE_FILE_UPLOAD_TEMPLATE: {
    page: 'Upload template file',
    target: 'customize-upload-file-template',
    label: 'Customize upload file template',
  },
  DASHBOARD: {
    ADD_USER: {
      page: 'Dashboard',
      target: 'add-user',
      label: 'Add user',
    },
    CREATE_TEMPLATE: {
      page: 'Dashboard',
      target: 'create-template',
      label: 'Create template',
    },
    CONDUCT_INSPECTIONS: {
      page: 'Dashboard',
      target: 'conduct-inspections',
      label: 'Learn more',
    },
    SOLVE_ISSUES: {
      page: 'Dashboard',
      target: 'solve-issues',
      label: 'Learn more',
    },
    SEE_REPORTS: {
      page: 'Dashboard',
      target: 'see-reports',
      label: 'Learn more',
    },
    BOOK_DEMO: {
      page: 'Dashboard',
      target: 'book-demo',
      label: 'Book demo',
    },
  },
  TILES: {
    NUMBER_OF: {
      INSPECTIONS: {
        page: 'Dashboard',
        target: 'inspections-tile-click',
        label: 'Number of inspections',
      },
      NEGATIVE_RESPONSES: {
        page: 'Dashboard',
        target: 'negative-responses-tile-click',
        label: 'Number of negeative responses',
      },
      AVERAGE_SCORE: {
        page: 'Dashboard',
        target: 'average-score-tile-click',
        label: 'Number of average score',
      },
      OVERDUE_INSPECTIONS: {
        page: 'Dashboard',
        target: 'overdue-inspections-tile-click',
        label: 'Number of overdue inspections',
      },
      ISSUES: {
        page: 'Dashboard',
        target: 'issues-tile-click',
        label: 'Number of issues',
      },
    },
    ITEMS: {
      OVERDUE_INSPECTIONS_ISSUES: {
        page: 'Dashboard',
        target: 'overdue-inspections-issues-click',
        label: 'Overdue inspection/issue item',
      },
      RECENTLY_CREATED_ISSUES: {
        page: 'Dashboard',
        target: 'recently-created-issues-click',
        label: 'Recently created issue item',
      },
      LAST_NEGATIVE_RESPONSES: {
        page: 'Dashboard',
        target: 'negative-responses-click',
        label: 'Last negative responses item',
      },
      RECENTLY_DONE: {
        page: 'Dashboard',
        target: 'recently-done-click',
        label: 'Recently done item',
      },
      ASSIGNED_TO_YOU: {
        page: 'Dashboard',
        target: 'assigned-to-you-click',
        label: 'Assigned to you item',
      },
      ISSUES_WO_ASSIGNEE_DEADLINE: {
        page: 'Dashboard',
        target: 'issues-to-be-done-click',
        label: 'Issues to be done W/O assignee or deadline item',
      },
    },
  },
  EXPORT_PDF: {
    page: 'Inspection report',
    target: 'pdf-export',
    label: 'Export PDF',
  },
  EXPORT_PHOTOS: {
    page: 'Inspection report',
    target: 'photo-export',
    label: 'Download photos',
  },
  EDIT_REPORT: {
    page: 'Inspection report',
    target: 'edit-inspection',
    label: 'Edit report',
  },
  CHANGE_PASSWORD: {
    page: 'Profile',
    target: 'change-password',
    label: 'Change password',
  },
  SKIP_SEGMENTATION_STEP: {
    page: 'User segmentation',
    target: 'skip-segmentation-step',
    label: 'Skip segmentation step',
  },
  CONTINUE_SEGMENTATION_STEP: {
    page: 'User segmentation',
    target: 'continue-segmentation-step',
    label: 'Continue segmentation step',
  },
};
